// Nexo client helper - ver https://dev.tiendanube.com/docs/developer-tools/nexo

import { create, connect, iAmReady, type NexoClient } from '@tiendanube/nexo';

const getClientId = (): string => {
  const urlParams = new URLSearchParams(window.location.search);
  const appId = urlParams.get('appId');
  console.log('url', window.location.href, 'appId', appId);
  return appId || '1111';
};

let nexoInstance: NexoClient | null = null;

/**
 * Inicializa y conecta Nexo con el Administrador de Tiendanube
 * Esto es necesario para que la aplicación funcione correctamente en el iframe
 */
export const initializeNexo = async (): Promise<NexoClient> => {
  if (nexoInstance) {
    return nexoInstance;
  }

  const clientId = getClientId();
  const candidate = create({
    clientId,
    log: import.meta.env.DEV,
  });

  try {
    await connect(candidate);
    iAmReady(candidate);
    console.log('Nexo conectado');
    nexoInstance = candidate;
    return nexoInstance;
  } catch (error) {
    console.warn('Error al conectar Nexo (tiene que estar conectado iframe de Tiendanube):', error);
    throw error;
  }
};

/**
 * Obtiene la instancia de Nexo (si está inicializada)
 */
export const getNexoInstance = (): NexoClient | null => {
  return nexoInstance;
};
